module.exports = __webpack_public_path__ + "static/media/RP-B_C_Embroidery_Vela_Dark grey_White.5b966a31.png";